// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"ea5b8cdd","551":"339bf09d","732":"bab2cd25","977":"b95bdf29"}[chunkId] + ".chunk.js";
};